module.exports = __webpack_public_path__ + "img/icon_to_top.e9f02def.png";